const defaultSectionValues = {
    __typename: 'Section',
    categories: null,
    items: [],
    limit: null,
    links: null,
    permissions: null,
    size: null,
    stretchedContent: null,
    subTitle: null,
    title: null,
    visibility: {
        __typename: 'Visibility',
        hiddenForFF: null,
        hideOnBreakpoint: null,
    },
};
const defaultItemValues = {
    __typename: 'Item',
    author: null,
    categories: null,
    contentPosition: null,
    featured: null,
    icon: null,
    length: null,
    links: null,
    mobile: null,
    note: null,
    permissions: null,
    size: null,
    source: null,
    url: null,
    content: null,
    image: null,
    video: null,
    backgroundColor: null,
    place: null,
    date: null,
    dismissable: null,
    speakers: [],
};
const defaultPermissionsValues = {
    __typename: 'Permissions',
    audience: null,
    categories: null,
    roles: null,
};
const defaultLinkValues = {
    __typename: 'Link',
    icon: null,
    text: null,
    variant: null,
};
const defaultSizeValues = {
    __typename: 'Size',
    lg: null,
    md: null,
    sm: null,
    xl: null,
    xs: null,
};
const defaultSectionSubtitleValues = {
    __typename: 'SectionSubTitle',
    visibility: {
        __typename: 'Visibility',
        hiddenForFF: null,
        hideOnBreakpoint: null,
    },
};
const defaultItemMobileValues = {
    __typename: 'ItemMobile',
    description: null,
    icon: null,
};
const defaultResponsiveImageValues = {
    __typename: 'ResponsiveImage',
    alt: null,
    source: {
        __typename: 'ResponsiveSource',
        xs: null,
        sm: null,
        md: null,
        lg: null,
        xl: null,
    },
};
const defaultSingleImageValues = {
    __typename: 'SingleImage',
    alt: null,
};
const defaultVideoValues = {
    __typename: 'Video',
    standard: {
        __typename: 'VideoSource',
        backgroundColor: null,
        src: null,
        poster: null,
    },
    retina: {
        __typename: 'VideoSource',
        backgroundColor: null,
        src: null,
        poster: null,
    },
};
const defaultCommunityGridValues = {
    __typename: 'CommunityGrid',
    preferences: null,
};
const defaultCommunitySliderValues = {
    __typename: 'CommunitySlider',
    preferences: null,
};
const defaultCommunityListingValues = {
    __typename: 'CommunityListing',
    preferences: null,
};
const defaultCommunityHeroValues = {
    __typename: 'CommunityHero',
    image: null,
    video: null,
    backgroundColor: null,
    content: null,
    contentPosition: null,
    icon: null,
    links: null,
    size: null,
};

export { defaultCommunityGridValues, defaultCommunityHeroValues, defaultCommunityListingValues, defaultCommunitySliderValues, defaultItemMobileValues, defaultItemValues, defaultLinkValues, defaultPermissionsValues, defaultResponsiveImageValues, defaultSectionSubtitleValues, defaultSectionValues, defaultSingleImageValues, defaultSizeValues, defaultVideoValues };
